import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as _ from 'lodash';
import { UiService } from '../../../../../core/services/core.ui.service';
import { GfTranslateService } from '../../../../../core/services/core.translate.service';
import { xformFileData } from '../../../../../core/services/core.xform-file-data.function';

@Component({
  selector: 'csv-upload',
  template: require('./csvUpload.component.html')
})
export class CsvUploadComponent implements OnInit {

  @Input() tracker: any; // Adjust type accordingly
  @Output() onComplete = new EventEmitter<void>();

  public upload: any = this.newUpload();

  constructor(
    private http: HttpClient,
    private uiService: UiService,
    private gfTranslateService: GfTranslateService
  ) { }

  ngOnInit(): void {
  }

  validate(): boolean {
    this.upload.invalid = false;

    if (!this.upload.file) {
      this.upload.invalid = "Please choose a file to import";
      return false;
    }

    let fileType = _.get(this.upload.file, 'type', 'unknown');
    fileType = fileType === '' ? 'unknown' : fileType;

    if (fileType !== 'text/csv') {
      this.upload.invalid = `Sorry, (${fileType}) is not a valid type for CSV import`;
      return false;
    }

    return true;
  }

  uploadCSV(): void {
    if (!this.validate()) {
      return;
    }

    let url = `/api/tracker/${this.tracker.id}/csv`;

    /*
    const formData: FormData = new FormData();
    formData.append('id', this.tracker.id);
    formData.append('csv-file', this.upload.file);
    */

    // Prepare your data object
    const data = {
      'id': this.tracker.id,
      'csv-file': this.upload.file
    };
    
    // Transform the data using xformFileData
    const formData = xformFileData(data);

    this.http.post(url, formData).subscribe(
      (response: any) => {
        this.upload.result = _.get(response, 'data', { changes: {}, errors: {} });
      },
      (error) => {
        this.uiService.showErrorMsg(`Failed to process csv: ${error.error}`, 'CSV Upload');
      },
      () => {
        this.onClose();
      }
    );
  }

  onClose(): void {
    this.resetCSV();
    setTimeout(() => {
      this.onComplete.emit();
    }, 750);
  }

  resetCSV(): void {
    this.upload = this.newUpload();
  }

  fileSelected(event: any): void {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    this.resetCSV();
    this.upload.file = file;
  }

  newUpload(): any {
    return {
      file: false,
      uploading: false,
      invalid: false,
      result: false
    };
  }
}

